/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SearchV2SortField } from "~/generated/graphql";
import { SortDirection, SortSelector, Option } from "~/components";

const SELECT_OPTIONS = [
  {
    value: SearchV2SortField.Cost,
    label: "Monthly Costs",
  },
  {
    value: SearchV2SortField.Type,
    label: "Type/Subtype",
  },
  {
    value: SearchV2SortField.Region,
    label: "Region",
  },
  {
    value: SearchV2SortField.ProviderId,
    label: "Resource name",
  },
  {
    value: SearchV2SortField.SavingsAmount,
    label: "Savings amount",
  },
];

type Props<S> = {
  sortField: string;
  sortDirection: SortDirection;
  onSortSelect: (value: S) => void;
  onSortOrderChange: (value: SortDirection) => void;
  options?: Option[];
  disabled?: boolean;
};

export function EstateSortV2<S>({
  sortField,
  sortDirection,
  onSortSelect,
  onSortOrderChange,
  options = SELECT_OPTIONS,
  disabled = false,
}: Props<S>) {
  return (
    <SortSelector
      options={options}
      value={sortField}
      direction={sortDirection}
      disabled={disabled}
      onSelect={(filter) => onSortSelect(filter as S)}
      onSortChange={(direction) => onSortOrderChange(direction)}
    />
  );
}
